"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectLocale = selectLocale;
exports.selectUseWorkflow = selectUseWorkflow;
exports.default = void 0;

var _immutable = require("immutable");

var _config = require("../actions/config");

var _publishModes = require("../constants/publishModes");

const defaultState = (0, _immutable.Map)({
  isFetching: true
});

function config(state = defaultState, action) {
  switch (action.type) {
    case _config.CONFIG_REQUEST:
      return state.set('isFetching', true);

    case _config.CONFIG_SUCCESS:
      /**
       * The loadConfig action merges any existing config into the loaded config
       * before firing this action (so the resulting config can be validated),
       * so we don't have to merge it here.
       */
      return action.payload;

    case _config.CONFIG_FAILURE:
      return state.withMutations(s => {
        s.delete('isFetching');
        s.set('error', action.payload.toString());
      });

    default:
      return state;
  }
}

function selectLocale(state) {
  return state.get('locale', 'en');
}

function selectUseWorkflow(state) {
  return state.get('publish_mode') === _publishModes.EDITORIAL_WORKFLOW;
}

var _default = config;
exports.default = _default;